<template>
    <div class="tab-body">
        <el-row class="autoFlex" :gutter="10" v-if="popupLoading">

            <el-col :span="4">
                <el-card class="leftCard">
                    <div slot="header" class="clearfix">
                        <span>{{ course }}</span>
                        <el-button @click="expandTree" class="expandBtn" type="primary" icon="el-icon-s-fold"
                            size="mini" style="margin-left: 20px; float: right"></el-button>
                    </div>
                    <tree v-loading="treeLoading" ref="permissionTree" :items="moudelList"
                        :defaultExpandAll="treeExpand" :defaultParent="0" @nodeClick="treeClick"></tree>
                </el-card>
            </el-col>

            <el-col :span="20">
                <el-card class="rightCard">
                    <div class="dataTable autoFlex">
                        <qlh-table class="table" style="height: auto" :data="subjectTable" stripe border
                            height="auto" :excelProp="excelProp">
                            <qlh-table-column prop=name :label="`${Subflag}名`" min-width="130" :editable="false">
                            </qlh-table-column>
                            <qlh-table-column prop=days :label="`${Subflag}天数`" min-width="100" :width="120"
                                :editable="false">
                            </qlh-table-column>
                            <qlh-table-column prop=level label="等级" width="120" :formatter="(row, column) => {
            return row.level == 1
                ? '容易'
                : row.level == 2
                    ? '一般'
                    : '困难'
                ;
        }
            "></qlh-table-column>
                            <qlh-table-column label="学习资源包 " fixed="right" width="500" ignored :editable="false">

                                <template slot-scope="scope">
                                    <div class="dataTable-operator" v-if="scope.row.id != '10044'">
                                        <el-button size="mini"  type="success"  v-if="scope.row.pid=='0'"
                                            @click="toDocument(scope.$index, scope.row, 9)">
                                            学习总结[{{ scope.row.exmcnt?scope.row.exmcnt:0 }}]
                                        </el-button>

                                        <el-button size="mini" type="primary"
                                            @click="toDocument(scope.$index, scope.row, 1)">
                                            文档 [{{ scope.row.doccnt?scope.row.doccnt:0 }}]
                                        </el-button>

                                        <el-button size="mini" type="warning"
                                            @click="toDocument(scope.$index, scope.row, 2)">
                                            视频[{{ scope.row.vdocnt?scope.row.vdocnt:0 }}]
                                        </el-button>
                                        <el-button size="mini" type="primary"
                                            @click="toDocument(scope.$index, scope.row, 3)">
                                            笔记[{{ scope.row.notecnt? scope.row.notecnt:0 }}]
                                        </el-button>
                                        <el-button size="mini" type="warning"
                                            @click="toDocument(scope.$index, scope.row, 4)">
                                            资料[{{ scope.row.codecnt?scope.row.codecnt:0 }}]
                                        </el-button>
                                    </div>

                                </template>

                            </qlh-table-column>
                        </qlh-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div>
            <el-dialog title="课程视频地址查看" :visible.sync="dialogVisible" width="42%">
                <span :key="index" v-for="(tag, index) in urlList">
                    <el-tag size="medium" type="success">{{ tag.k }}</el-tag>
                    <el-tag size="medium">{{ tag.v }}</el-tag><br />
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <edit ref="edit"></edit>
    </div>
</template>
<script>
import edit from "./edit.vue";
import tree from "@/components/tree/tree.vue";
import api from "@/api/edu/subject/subject.js";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
export default {
    name: "course",
    components: {
        tree,
        api,
        qlhTable,
        qlhTableColumn,
        edit,
    },
    data() {
        return {
            Subflag: "模块",

            showSub :true,

            dialogVisible: false,
            popupLoading: true,
            treeLoading: false,
            treeRef: "permissionTree",
            treeExpand: false,
            moudelList: [],
            urlList: [],
            currentNode: {},
            subjectTable: [],
            tableLoading: true,
            editParameter: {},
            course: "",
            clickedSubID: "",
            excelProp: {
                excelName: "科目信息",
                sheetname: "科目信息",
            },
        };
    },
    methods: {

        //获取数据
        list() {
            this.treeLoading = true;
            api.list({}, (response) => {
                // this.urlList = JSON.parse(response.data.url);
                this.moudelList = response.data;
                this.treeLoading = false;
                this.freshTable();
            });
            //this.freshTable();
        },
        expandTree() {
            this.treeExpand = !this.treeExpand;
            //控制el-tree展开收起
            for (
                var i = 0;
                i < this.$refs.permissionTree.getTree().store._getAllNodes().length;
                i++
            ) {
                this.$refs.permissionTree.getTree().store._getAllNodes()[
                    i
                ].expanded = this.treeExpand;
            }
        },
        treeClick(data) {

           
               if(this.clickedSubID &&   this.clickedSubID != data.id){
                  this.showSub =true
                }
                if ( !this.showSub ) {
                    this.Subflag = "模块";
                    this.currentNode = {};
                } else {
                    this.Subflag = "子科目";
                    this.currentNode =  data;
                }
                this.clickedSubID = data.id
                this.freshTable(data);
                this.showSub =  !this.showSub
             
        },
        freshTable(data) {
            this.tableLoading = true;
            this.subjectTable = [];

            if (this.currentNode.id) {
             //   console.log( "this.clickedSubID",this.clickedSubID )
                if (this.clickedSubID) {
                    api.list({ pid: this.clickedSubID }, (response) => {
                        if(response.data && response.data.length > 0){
                             this.subjectTable = response.data;
                        }else{
                             this.subjectTable = [data];
                        }
                       
                        this.$forceUpdate()
                        this.treeLoading = false;
                    });
                } else {
                    this.subjectTable = this.moudelList.filter(mod => mod.pid == "0");
                }
            } else {
                this.subjectTable = this.moudelList.filter(mod => mod.pid == "0");
            }
            this.tableLoading = false;
        },
        //視頻
        toUpdate(index, row) {
            let parameter = {
                id: row.id,
            };
            this.$refs.edit.open(parameter, this.Subflag + "-[" + row.name + "]-资源详情");
        },
        //詳情
        toDetail(index, row) {
            let detailParameter = {
                id: row.id,
            };
            console.log(detailParameter)
            this.$refs.edit.open(detailParameter, "详情", true);
        },

        toDocument(index, row, type) {
            let parameter = {
                id: row.id,
                type: type
            };
            let title = "学习总结"
            if (type == 1) {
                title = "文档"
            } else if (type == 2) {
                title = "视频"
            } else if (type == 3) {
                title = "笔记"
            } else if (type == 4) {
                title = "资料"
            }
            this.$refs.edit.open(parameter, this.Subflag + "-[" + row.name + "]-" + title);
        },

    },

    mounted() {
        this.list();
        this.course = this.$caches.myCourse.get();
    },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>